<script setup lang="ts">
import { ref, defineEmits } from "vue";

type Emits = {
  files: [files: FileList];
  change: [event: Event];
};

const emit = defineEmits<Emits>();
const props = defineProps<{ accept?: string; multiple?: boolean }>();

const input = ref<HTMLInputElement | null>(null);

function onChange(event: Event) {
  if (event.target instanceof HTMLInputElement) {
    emit("files", event.target.files as FileList);
  }
  emit("change", event);
}

function upload() {
  if (input.value) input.value.click();
}
</script>
<template>
  <input
    ref="input"
    type="file"
    :accept="props.accept"
    :multiple="props.multiple"
    @change="onChange"
  />
  <slot :upload="upload" />
</template>
<style scoped>
input {
  opacity: 0;
  width: 0;
  height: 0;
}
</style>
